import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';
import orderBy from 'lodash/orderBy';
import unionBy from 'lodash/unionBy';
import { withNamespaces } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import ApplicationTable from './ApplicationTable';
import { Constants } from '../../common/constants/index';

const { home, common } = Constants;
const { ASC, DESC } = common;
const { COLUMN_SORT_NAMES } = home;
const { 
  APP_NAME, 
  APP_DESCRIPTION, 
  CONSTITUENT_TYPE, 
  SEARCH_TERM, 
  PROVIDED_BY 
} = COLUMN_SORT_NAMES;

export class ApplicationSearch extends Component {
  static propTypes = {
   applications: PropTypes.array
  };

  state = {
    formattedApplications: [],
    sortDir: ASC,
    sortCol: COLUMN_SORT_NAMES.APP_NAME,
    searchValue: ''
  }

  constructor(props){
    super(props);

    this.mapAfq = this.mapAfq.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
  }

  componentDidMount(){
    const { applications } = this.props;
    const newApplications = applications.map(this.mapAfq);
    this.setState({
      formattedApplications: newApplications
    });
  }

  /**
   * Maps api afq version object to simple afq object for table
   * 
   * @param {Object} apiAfq
   * @returns {{ 
   *  id: number,
   *  vanity_url: string,
   *  agency_url: string,
   *  app_name: string,
   *  app_description: string,
   *  constituent_type: string,
   *  search_term: string,
   *  provided_by: string 
   * }} 
   */
  mapAfq(apiAfq){
    //TODO: Possibly remove this when api response is stablized
    
    return {
      id: apiAfq.id,
      vanity_url: apiAfq.appVanityUrl,
      agency_url: apiAfq.agencyWebsiteUrl,
      [APP_NAME]: apiAfq.appDisplayName,
      [APP_DESCRIPTION]: apiAfq.appDescription,
      [CONSTITUENT_TYPE]: apiAfq.constituentType,
      [SEARCH_TERM]: apiAfq.searchTerm,
      [PROVIDED_BY]: apiAfq.providerAgencyName
    };
  }

  handleSearch(e){
    e.preventDefault();
    const { applications } = this.props;
    const { searchValue } = this.state;
    let newApplications = [];
    const formattedApplications = applications.map(this.mapAfq);

    if(!searchValue.trim().length){
      newApplications = formattedApplications;
    } else {
      const searchTerms = this.pullSearchTerms(searchValue);
      
      /* 
        filters all columns by each term then gets all unique 
        matching applications by id to prevent duplicates
      */
      newApplications = searchTerms
        .map( term => this.filterApplications(term, formattedApplications))
        .reduce((prev, current)=> unionBy(prev, current, 'id'));
    }
    
    this.setState({
      formattedApplications: newApplications
    });
  }

  // TODO: Made a seperate function for possible future extension
  pullSearchTerms(searchStr) {
    return searchStr.split(',');
  }

  filterApplications(searchTerm, applications) {
    return applications.filter(application => {

      // Check if any application object values contain search value
      const values = Object.values(application).filter(val => {
        return isString(val) ? this.matchTerm(searchTerm, val): false;
      });

      return values.length;
    });
  }

  matchTerm(searchTerm, value){
    return value
      .toLowerCase()
      .includes(searchTerm.trim().toLowerCase());
  }

  handleSearchInputChange(e){
    this.setState({
      searchValue: e.target.value
    });
  }

  handleColumnSort = (name, direction) => {
    const { formattedApplications, sortDir, sortCol } = this.state;
    let newSortDir = direction || ASC;
    
    if(name === sortCol && !direction) {
      newSortDir = sortDir === ASC ? DESC : ASC;
    }

    const getSortValue = app => {
      return app[name] ? app[name].toLowerCase() : '';
    };

    const newApplications = orderBy(formattedApplications, [getSortValue], [newSortDir]);

    this.setState({
      formattedApplications: newApplications,
      sortCol: name,
      sortDir: newSortDir
    });
  };
  

  render() {
    const { formattedApplications, sortDir, sortCol, searchValue } = this.state;
    const { t } = this.props;
    const appLength = formattedApplications.length;
    return (
      <div className="home-application-search">
        <h2 className="home-application-search__header h5"><FontAwesomeIcon icon={faSearch} /> {t('application_search.title')}</h2>
        <p>{t('application_search.instructions')}</p>
        <form onSubmit={this.handleSearch} className="usa-form">
            <div className="grid-row">
              <div className="desktop-lg:grid-col-11 tablet:grid-col-10">
                <label htmlFor="search-input" className="usa-label text-bold">
                  {t('application_search.find_text')}
                </label>
                <input
                  id="search-input"
                  className="usa-input home-application-search__input radius-md"
                  placeholder={t('application_search.placeholder')}
                  value={searchValue}
                  onChange={this.handleSearchInputChange}
                />
              </div>
              <div className="desktop-lg:grid-col-1 tablet:grid-col-2">
                <input type="submit" className="usa-button home-application-search__button float-right margin-right-0" value={t('application_search.search_btn')} />
              </div>
            </div>
        </form>
        <div className="margin-top-4 font-body-sm text-bold">{t('application_search.showing', { from: appLength ? 1 : 0, to: appLength, total: appLength})}</div>
        <ApplicationTable 
          applications={formattedApplications}
          sortDir={sortDir}
          sortCol={sortCol}
          onSort={this.handleColumnSort}
        />
      </div>
    );
  }
}


export default withNamespaces('home')(ApplicationSearch);



// WEBPACK FOOTER //
// ./src/features/home/ApplicationSearch.js